import { Card, Col, Flex, Row, Tabs, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { DraftCalendarView } from "../DraftComponents";
import {
  dateTimeToUtc,
  getEndDateTime,
  getStartDateTime,
  onlyDateFun,
} from "../../shared";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";
import { draftapi } from "../../services/draftapi";
import ViewCalendarAppointment from "../../pages/ppointments/ViewCalendarAppointment";

const { Title, Text } = Typography;

const DashboardCalendarView = () => {
  const [draftData, setDraftData] = useState([]);

  useEffect(() => {
    getDraft();
  }, []);

  const getDraft = async () => {
    const startDate = dayjs().startOf("year").format("YYYY-MM-DD");
    const endDate = dayjs().endOf("year").format("YYYY-MM-DD");
    const params = {
      startDate: dateTimeToUtc(getStartDateTime(startDate)),
      endDate: dateTimeToUtc(getEndDateTime(endDate)),
      pagination: false,
    };
    const response = await draftapi?.getAllDrafs(params);
    let drafts = response?.data ?? [];

    drafts = drafts.map((draft) => ({
      id: draft?.id,
      alldata: draft || "",
    }));

    const events = drafts.map((draft) => ({
      ...draft,
      status: draft.alldata?.follow_up_status,
      start: draft.alldata?.when_to_call_again
        ? dayjs(draft.alldata.when_to_call_again).toDate()
        : new Date(),
      end: draft.alldata?.when_to_call_again
        ? dayjs(draft.alldata.when_to_call_again).add(1, "hour").toDate()
        : dayjs().add(1, "hour").toDate(),
      title: draft.alldata?.client?.name,
    }));

    setDraftData(events);
  };
  const onChange = (key) => {
    console.log(key);
  };

  const items = [
    {
      key: "1",
      label: "Session",
      children: <ViewCalendarAppointment />,
    },
    {
      key: "2",
      label: "Draft",
      children: (
        <Flex vertical gap={16}>
          <Row gutter={[16, 16]} justify="space-between" align={"top"} gap>
            <Col span={24} lg={6}>
              <Flex vertical gap={1}>
                <Title level={4} className="m-0">
                  Drafts{" "}
                </Title>
                <Text className="fs-13">{draftData?.length} draft</Text>
              </Flex>
            </Col>
            <Col span={24} lg={18}>
              <Flex gap={10} wrap justify="end">
                <Flex gap={2} align="center">
                  <div className="color-b completed"></div>
                  <Text className="fs-12">Appointment scheduled</Text>
                </Flex>
                <Flex gap={2} align="center">
                  <div className="color-b pending"></div>
                  <Text className="fs-12">Pending</Text>
                </Flex>
                <Flex gap={2} align="center">
                  <div className="color-b maginta"></div>
                  <Text className="fs-12">Callback required</Text>
                </Flex>
                <Flex gap={2} align="center">
                  <div className="color-b gold"></div>
                  <Text className="fs-12">Called</Text>
                </Flex>
                <Flex gap={2} align="center">
                  <div className="color-b blued"></div>
                  <Text className="fs-12">No response</Text>
                </Flex>
                <Flex gap={2} align="center">
                  <div className="color-b cancelled"></div>
                  <Text className="fs-12">Not interested</Text>
                </Flex>
              </Flex>
            </Col>
          </Row>
          <DraftCalendarView draftData={draftData} getDraft={getDraft} />
        </Flex>
      ),
    },
  ];

  return (
    <Card className="border-gray">
      <Flex vertical gap={10}>
        <Title level={4} className="m-0">
          Session & Draft Calendar View
        </Title>
        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
      </Flex>
    </Card>
  );
};

export { DashboardCalendarView };
